const checkResponseOk = async res => {
	if (res.ok) return;
	const err = new Error(res.statusText);
	err.res = res;
	err.body = await res.json();
	throw err;
};

export default checkResponseOk;
